import { render } from "./Detail.vue?vue&type=template&id=e2187530&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=e2187530&lang=scss&scoped=true"
import "./Detail.vue?vue&type=style&index=1&id=e2187530&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2187530"]])

export default __exports__